module.exports = __webpack_public_path__ + "img/21_23.ed0c1e98.png";